<template>
  <VueFragment>
    <HomeBanner />
    <AboutMeSnippet />
  </VueFragment>
</template>

<script>
import { Fragment as VueFragment } from 'vue-fragment';

import AboutMeSnippet from '../components/AboutMeSnippet.vue';
import HomeBanner from '../components/HomeBanner.vue';

export default {
  name: 'HomePage',
  components: {
    AboutMeSnippet,
    HomeBanner,
    VueFragment
  }
};
</script>

<style lang="scss">
</style>
